import axios from '@axios'
import axiosDefaultConfig from '@core/app-config/axiosDefaultConfig'

export default {
  namespaced: true,
  actions: {
    calculate(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${axiosDefaultConfig.backendEndPoint}calculation/ro`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    sendOfferMail(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`${axiosDefaultConfig.backendEndPoint}calculation/offer`, data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
